import List from '@pelckmans/elementis/components/list';
import Section from '@pelckmans/elementis/components/section';
import { useCallback, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Medialink } from '../../../../../api/medialink';
import { ANALYTICS_EVENT_SUBLOCATIONS } from '../../../../../constants/analyticsEvents';
import MyAssignmentsContext from '../../../../../contexts/MyAssignmentsContext';
import { AssignmentDeadlinePill } from '../../../../../shared-components/AssignmentDeadlinePill';
import MedialinkListItem from '../MedialinkListItem';

interface Props {
  medialinks: Medialink[];
  getMedialinksForExerciseCategory: () => Promise<void>;
}

function AssignmentMedialinksSection({ medialinks, getMedialinksForExerciseCategory }: Props) {
  const { refreshAssignments } = useContext(MyAssignmentsContext);

  const { t } = useTranslation();

  const fetchAssignmentsAndMedialinks = useCallback(
    async () => Promise.all([getMedialinksForExerciseCategory(), refreshAssignments()]),
    [getMedialinksForExerciseCategory, refreshAssignments],
  );

  if (medialinks.length === 0) {
    return null;
  }

  return (
    <Section title={t('PAGES.VEM.MATERIAL_SECTION.ASSIGNMENTS.TITLE')}>
      <List>
        {medialinks.map(m => (
          <MedialinkListItem
            key={m.id}
            medialink={m}
            onCloseCallback={fetchAssignmentsAndMedialinks}
            scorable={true}
            pills={m.assignments[0] && <AssignmentDeadlinePill deadline={m.assignments[0].to} />}
            subLocationId={ANALYTICS_EVENT_SUBLOCATIONS.PORTAAL_VIRTUAL_EXERCISE_MODULE_ASSIGNMENT_MATERIAL}
          />
        ))}
      </List>
    </Section>
  );
}

export default AssignmentMedialinksSection;
